import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Card } from '@/components/sections/Card';
import { FunctionComponent } from 'react';

interface FinanceModelUserGuideProps {}

const FinanceModelUserGuide: FunctionComponent<FinanceModelUserGuideProps> = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Finance / Purchase Models User Guide',
      to: ''
    }
  ];

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title="Finance / Purchase Models User Guide" breadcrumbs={breadcrumbs} />
      <div className="px-6 py-8 h-full text-lg overflow-y-auto">
        <Card className="p-5 space-y-5">
          <div className="space-y-1">
            <p className="text-xl font-semibold">Capital Purchase</p>
            <p>You pay for and own the goods. Typically on 30 days terms.</p>

            <p>
              Once you have picked your standardised products, here is where you select which finance/procurement method
              suits your organisation best.
            </p>

            <p>NOTE: there is a min value to do a finance order of £1,500.</p>
          </div>
          <div className="space-y-1">
            <p>We have 2 options:</p>

            <p className="text-xl font-semibold">FMV - 'Fair Market Value' lease</p>

            <p>FMV applies to devices only!</p>

            <p>Options: 2 and 3 years</p>

            <p>Features:</p>
            <ul className="list-disc ml-5">
              <li>No upfront cost and spread the payments over the term</li>
              <li>You pay less than the cash price. Example: £1000 device, you pay £920*</li>
              <li>There is no cost of capital - %APR.</li>
              <li>Customer must return the device at the end of the term</li>
              <li>Penalties apply for damaged devices returned at the end of the term</li>
              <li>Fixed Term, non-cancellable</li>
              <li>NOTE: there is a min value to do a finance order of £1,500.</li>
            </ul>
            <p className="font-semibold">*example is indicative only</p>
          </div>
          <div className="space-y-1">
            <p className="text-xl font-semibold">FPL - Full Payout Lease</p>
            <p>Applies to everything - Devices, peripherals and services</p>
            <p>Options: 3,4 & 5 years</p>
            <p>Features:</p>

            <ul className="list-disc ml-5">
              <li>No upfront cost and spread the payments over the term</li>
              <li>% APR applied. Example: £1000 device, you pay £1140 over 3 years*</li>
              <li>Customer owns the equipment at the end of the period</li>
              <li>Fixed Term, non-cancellable</li>
              <li>NOTE: there is a min value to do a finance order of £1,500.</li>
            </ul>
            <div>
              <p className="font-semibold">*example is indicative only</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default FinanceModelUserGuide;
